enum EVENTS {
  // Used for running jest tests
  EVENT_TEST = 'EVENT_TEST',
  // Internally used by CoreFacade to tell 360 that it needs to clean the page
  ROUTE_TO_V2 = 'ROUTE_TO_V2',
  // Internally used by 360 to signal when it finished loading.
  FINISH_360_BOOTSTRAP = 'FINISH_360_BOOTSTRAP',
  // Internally used by 360 to signal that the logged-in user has no workspace access.
  NO_WORKSPACE_ACCESS = 'NO_WORKSPACE_ACCESS',
  // Dispatched by 360 once the user's feature tags have been fetched.
  FEATURE_TAGS_LOADED = 'FEATURE_TAGS_LOADED',
  // To be used for triggering page changes across the dashboard
  CHANGE_PAGE = 'CHANGE_PAGE',
  // To be used when switching users
  SWITCH_USER = 'SWITCH_USER',
  // Internally used by the Bridge to observe changes in sharedState
  SHARED_STATE_CHANGED = 'SHARED_STATE_CHANGED',
  // Used internally by V2 to communicate showing legacy styled toast notifications
  LEGACY_STYLED_TOAST_NOTIFICATION_SHOW = 'LEGACY_STYLED_TOAST_NOTIFICATION_SHOW',
  // Used internally by V2 to communicate showing  toast notifications
  TOAST_NOTIFICATION_SHOW = 'TOAST_NOTIFICATION_SHOW',
  // Dispatched to open the compose box
  OPEN_COMPOSE = 'OPEN_COMPOSE',
  // Dispatched when a message is saved
  COMPOSE_SAVE_COMPLETE = 'COMPOSE_SAVE_COMPLETE',
  // Dispatched when a message is deleted
  COMPOSE_DELETE_COMPLETE = 'COMPOSE_DELETE_COMPLETE',
  // Used internally by V2 to communicate opening compose box
  COMPOSEBOX_OPENED = 'COMPOSEBOX_OPENED',
  // Used internally by classic to communicate to V2 the click on ai assist button
  AI_ASSIST_CLICKED = 'AI_ASSIST_CLICKED',
  // Used internally by classic to communicate to V2 the compose mode
  COMPOSE_EDIT_MODE = 'COMPOSE_EDIT_MODE',
  // Open AI assist modal
  SHOW_AI_ASSIST = 'SHOW_AI_ASSIST',
  // Close AI assist modal
  CLOSE_AI_ASSIST = 'CLOSE_AI_ASSIST',
  // Send Generate content
  AI_ASSIST_GENERATED_CONTENT = 'AI_ASSIST_GENERATED_CONTENT',
  // Used internally by classic to communicate to V2 that the sidebar is open
  LEGACY_SIDEBAR_SHOW = 'LEGACY_SIDEBAR_SHOW',
  // Used by creative editor to communicate an exported image
  CREATIVE_EDITOR_IMAGE_EXPORT = 'CREATIVE_EDITOR_IMAGE_EXPORT',
  // Cancels all compose box standing uploads and closes Background uploader if it's not handling media library uploads
  CANCEL_ALL_UPLOADS_AND_CLOSE_BU = 'CANCEL_ALL_UPLOADS_AND_CLOSE_BU',
  // signals to sendible360 that media has been added
  MEDIA_ADDED = 'MEDIA_ADDED',
  // signals to sendible360 that media has been removed
  MEDIA_REMOVED = 'MEDIA_REMOVED',
  // signals to sendible360 that media has been updated
  MEDIA_UPDATED = 'MEDIA_UPDATED',
  // Open Video Editor
  OPEN_VIDEO_EDITOR = 'OPEN_VIDEO_EDITOR',
  // Open Photo Editor
  OPEN_PHOTO_EDITOR = 'OPEN_PHOTO_EDITOR',
  // Open alt text modal
  OPEN_ALT_TEXT_MODAL = 'OPEN_ALT_TEXT_MODAL',
  // Open tag modal
  OPEN_TAG_MODAL = 'OPEN_TAG_MODAL',
  // Alt text, video settings, etc changed
  MEDIA_PROPERTIES_UPDATED = 'MEDIA_PROPERTIES_UPDATED',
  // import a youtube link
  IMPORT_YT_LINK = 'IMPORT_YT_LINK',
  // used to signal upload readiness to background uploader
  UPLOAD_READY = 'UPLOAD_READY',
  // used to signal upload failures to background uploader
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  // used to signal upload cancellations to background uploader
  UPLOAD_MEDIA_CANCELLED = 'UPLOAD_MEDIA_CANCELLED',
  // used to signal upload progress updates to background uploader
  UPLOAD_PROGRESS = 'UPLOAD_PROGRESS',
  // Used by sendible 360 to tell FEv2 to open attach from URL modal with a given URL
  OPEN_ATTACH_FROM_URL_MODAL = 'OPEN_ATTACH_FROM_URL_MODAL',
  // used when 360 code needs to upload a url, e.g. from share widget which used post_picture attribute url's.
  UPLOAD_URL_TO_COMPOSE = 'UPLOAD_URL_TO_COMPOSE',
  // canva callback
  CANVA_IMAGE_CALLBACK = 'CANVA_IMAGE_CALLBACK',
  // Called instantly when an upload is triggered.
  PRE_UPLOAD = 'PRE_UPLOAD',
  // Called when user changes timezone.
  TIMEZONE_CHANGED = 'TIMEZONE_CHANGED',
  // Called when user toggles media preview.
  MEDIA_PREVIEW_TOGGLE = 'MEDIA_PREVIEW_TOGGLE',
  // Used by the bulk importer to upload a batch of CSV-row image/video URLs through the
  // new media system instead of passing them straight through to the API.
  BULK_IMPORT_UPLOAD_URLS = 'BULK_IMPORT_UPLOAD_URLS',
  // Signals to the bulk importer that a given row's URL upload has created a media record
  // (before it has finished processing) - see UPLOAD_READY/UPLOAD_FAILED for the outcome.
  BULK_IMPORT_MEDIA_CREATED = 'BULK_IMPORT_MEDIA_CREATED',
  // Fired synchronously the moment an upload is kicked off for a given compose tab (device
  // file selected, or a URL submitted) - before a media record even exists. Lets consumers
  // that don't have their own upload UI (e.g. the bulk importer's grid cell) show immediate
  // loading feedback rather than waiting for MEDIA_ADDED/UPLOAD_READY.
  MEDIA_UPLOAD_STARTED = 'MEDIA_UPLOAD_STARTED',
  // Fired by the background uploader's own "Cancel all" button. UPLOAD_MEDIA_CANCELLED only
  // ever reaches uploads that already have a media record, so a batch upload runner still
  // waiting to dispatch queued items behind a concurrency limit (e.g. BulkImportUploadBridge)
  // needs this instead, to stop starting any more of them.
  CANCEL_ALL_QUEUED_UPLOADS = 'CANCEL_ALL_QUEUED_UPLOADS',
}

export default EVENTS;
